module.exports = __webpack_public_path__ + "img/11.3217b02.jpg";